import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { CampaignService } from '../../../Services/Axios/Api';
import { toast } from 'react-toastify';
import { createSliderInstance } from '../../../Models/Slider';
import { createMediaGalleryInstance } from '../../../Models/MediaGallery';
import { createSimpleNewsTickerInstance } from '../../../Models/SimpleNewsTicker';

const HomeBuilder = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [components, setComponents] = useState({
        slider: null,
        campaigns: null,
        gallery: null
    });

    useEffect(() => {
        loadComponentsData();
    }, []);

    const loadComponentsData = async () => {
        try {
            setLoading(true);
            
            // Load Slider data
            const sliderInstance = createSliderInstance();
            await sliderInstance.load();
            
            // Load Campaigns data
            const campaignsResponse = await CampaignService.getCampaigns();
            
            // Load Gallery data
            const galleryInstance = createMediaGalleryInstance();
            await galleryInstance.load();

            // Load News Ticker data
            const newsTickerInstance = createSimpleNewsTickerInstance();
            await newsTickerInstance.load();

            setComponents({
                slider: sliderInstance.getData(),
                campaigns: campaignsResponse.result,
                gallery: galleryInstance.getData(),
                newsTicker: newsTickerInstance.getData()

            });
        } catch (error) {
            // toast.error('Failed to load components data');
            console.error('Error loading components:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEditComponent = (component) => {
        switch (component) {
            case 'slider':
                navigate('/bj-admin/pages/home/slider');
                break;
            case 'campaigns':
                navigate('/bj-admin/donations/campaigns');
                break;
            case 'gallery':
                navigate('/bj-admin/pages/home/gallery');
                break;
            case 'news-ticker':
                navigate('/bj-admin/pages/home/news-ticker');
                break;
            default:
                break;
        }
    };

    if (loading) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                <Spinner animation="border" variant="primary" />
            </Container>
        );
    }

    return (
        <Container className="mt-4">
            <h2 className="mb-4">Home Page Builder</h2>
            
            <Row className="g-4">
                {/* Slider Component */}
                <Col xs={12} md={6} lg={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Slider</Card.Title>
                            {/* <Card.Text>
                                {components.slider?.slides?.length || 0} slides configured
                            </Card.Text> */}
                            <Button 
                                variant="primary" 
                                onClick={() => handleEditComponent('slider')}
                            >
                                Edit Slider
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Campaigns Component */}
                <Col xs={12} md={6} lg={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Campaigns</Card.Title>
                            {/* <Card.Text>
                                {components.campaigns?.length || 0} campaigns active
                            </Card.Text> */}
                            <Button 
                                variant="primary" 
                                onClick={() => handleEditComponent('campaigns')}
                            >
                                Manage Campaigns
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Media Gallery Component */}
                <Col xs={12} md={6} lg={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Media Gallery</Card.Title>
                            {/* <Card.Text>
                                {components.gallery?.images?.length || 0} images in gallery
                            </Card.Text> */}
                            <Button 
                                variant="primary" 
                                onClick={() => handleEditComponent('gallery')}
                            >
                                Edit Gallery
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={6} lg={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>News Ticker</Card.Title>
                                {/* <Card.Text>
                                    {components.newsTicker?.newsItems?.length || 0} news items configured
                                </Card.Text> */}
                            <Button 
                                variant="primary" 
                                onClick={() => handleEditComponent('news-ticker')}
                            >
                                Manage News Ticker
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <div className="mt-4">
                <Button 
                    variant="secondary" 
                    onClick={() => navigate('/bj-admin')}
                >
                    Back to Dashboard
                </Button>
            </div>
        </Container>
    );
};

export default HomeBuilder;
